export default __webpack_public_path__ + "static/testimonialHolder2-4a3c3f3fe3616e2a6cb5f51eb535f52d.png";